import { Component, OnInit } from '@angular/core';
import { HttpQueriesService } from '../Services/http-queries.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from '../Services/storage.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-congres-virtuel-manager-stand',
  templateUrl: './congres-virtuel-manager-stand.component.html',
  styleUrls: ['./congres-virtuel-manager-stand.component.scss']
})
export class CongresVirtuelManagerStandComponent implements OnInit {

  access_code = {original:'YnAjYjR3eTJXZ2FXd1RHRg==', entered:null};
  showPopupAccess = true;

  stand_basic = {stand_id:null};

  server = null;

  stand = null;
  loading = true;
  error = false;

  doc_form = {document_title:null, document_description:null, filelink:null};
  prod_form = {prod_title:null, prod_descr:null, link_produit:null, prod_image:null};
  vid_form = {vid_title:null, vid_descr:null, vid_link:null};
  contact_form = {email:null, found:null, nom:null, fonction:null, telephone:null, whatsapp:null, linkedin:null, facebook:null, original_user_id:null};

  saving = false;
  deleting = false;

  constructor(private httpservice:HttpQueriesService, private route:ActivatedRoute, private standdata:StorageService, private router:Router) {
    this.stand_basic.stand_id = this.route.snapshot.paramMap.get('id');
    this.server = httpservice.getServer();
   }

  ngOnInit() {
    let code = localStorage.getItem('manager-code');
    this.checkManagerAccess(code);  
  }

  checkManagerAccess(code){
    if(code && btoa(code) == this.access_code.original){
      this.showPopupAccess = false;
      localStorage.setItem('manager-code', code);
      this.server = this.httpservice.getServer();
      this.loadStandData();
    }else{
      this.router.navigateByUrl('congres-virtuel-vc-manager');
    }
  }

  loadStandData(){
    this.httpservice.getStandData(this.stand_basic).subscribe(val=>{
      this.stand = val;
      this.loading = false;
      console.log(this.stand)

    }, error=>{
      this.loading = false;

    })
  }

  onFileChange(fileInput: any, type){
    const file = fileInput.target.files[0];
    let temp = {file:file, name:file.name, file_size:file.size};
    //(type == "pdf") ? this.doc_form.document_file = temp : this.prod_form.prod_image = temp;
  }

  saveDocument(docForm: NgForm){
    this.saving = true;
    this.doc_form['stand_id'] = this.stand_basic.stand_id;
    this.httpservice.addStandDoc(this.prepareFormData('pdf')).subscribe(v=>{
      this.saving = false;
      this.stand.documents.unshift(v);
      docForm.reset();

    }, error=>{
      this.saving = false;
      alert('Une erreur s\'est occurée, veuillez réessayer.');

    });
  }

  saveProduct(prodForm){
    this.saving = true;
    this.prod_form['stand_id'] = this.stand_basic.stand_id;
    this.httpservice.addStandProd(this.prepareFormData('image')).subscribe(v=>{
      this.saving = false;
      this.stand.produits.unshift(v);
      prodForm.reset();

    }, error=>{
      this.saving = false;
      alert('Une erreur s\'est occurée, veuillez réessayer.');

    });
  }

  prepareFormData(type){
    let formData = new FormData();
    if(type == "pdf"){
      //formData.append("document_file", this.doc_form.document_file.file)
      formData.append("form", JSON.stringify(this.doc_form));

    }else{
      formData.append("prod_img", this.prod_form.prod_image.file);
      formData.append("form", JSON.stringify(this.prod_form));

    }
   
    return formData;
  }

  saveVideo(vidForm){
    this.saving = true;
    this.vid_form['stand_id'] = this.stand_basic.stand_id;
    this.httpservice.addStandVid(this.vid_form).subscribe(v=>{
      this.saving = false;
      this.stand.videos.unshift(v);
      vidForm.reset();

    }, error=>{
      this.saving = false;
      alert('Une erreur s\'est occurée, veuillez réessayer.');

    });
  }

  saveContact(contactForm){
    this.saving = true;
    this.contact_form['stand_id'] = this.stand_basic.stand_id;
    this.httpservice.addStandContact(this.contact_form).subscribe(v=>{
      this.saving = false;
      this.stand.contacts.unshift(v);
      contactForm.reset();

    }, error=>{
      this.saving = false;
      alert('Une erreur s\'est occurée, veuillez réessayer.');

    });
  }

  searchUserByEmail(){
    this.saving = true;
    this.contact_form.found = false;
    this.httpservice.findUserByEmailCongres({email:this.contact_form.email}).subscribe(v=>{
      this.saving = false;
      this.contact_form.found = true;
      this.contact_form.nom = v['nom'] + ' ' + v['prenom'];
      this.contact_form.fonction = v['fonction'];
      this.contact_form.telephone = v['telephone'];
      this.contact_form.original_user_id = v['id'];

    }, error=>{
      this.saving = false;
      (error.error == 'notfound') ? alert('Cet email n\'existe pas dans la liste des exposants') : alert('Une erreur s\'est occurée, veuillez réessayer.');

    });
  }

  goBack($event){
    $event.preventDefault();
    this.router.navigateByUrl('/congres-virtuel-vc-manager');
  }

  deleteDocument(doc, doc_index){
    this.deleting = true;
    this.httpservice.vcDeleteDoc({doc_id:doc.document_id}).subscribe(val=>{
      this.deleting = false;
      this.stand.documents.splice(doc_index, 1);

    }, error=>{
      this.deleting = false;
    })
  }

  deleteProduct(prod, prod_index){
    this.deleting = true;
    this.httpservice.vcDeleteProd({prod_id:prod.produit_id}).subscribe(val=>{
      this.deleting = false;
      this.stand.produits.splice(prod_index, 1);

    }, error=>{
      this.deleting = false;
    })
  }

  deleteVideo(video, video_index){
    this.deleting = true;
    this.httpservice.vcDeleteVideo({video_id:video.video_id}).subscribe(val=>{
      this.deleting = false;
      this.stand.videos.splice(video_index, 1);

    }, error=>{
      this.deleting = false;
    })
  }

  deleteContact(contact, contact_index){
    this.deleting = true;
    this.httpservice.vcDeleteContact({contact_id:contact.contact_id}).subscribe(val=>{
      this.deleting = false;
      this.stand.contacts.splice(contact_index, 1);

    }, error=>{
      this.deleting = false;
    })
  }

}
